<template>
    <div class="needPayContainer">
        <van-nav-bar
                title="待支付订单"
                left-arrow
                @click-left="onClickBack"
            />
        <div class="needPayInfo" v-if="orderInfo != null" >
            <van-panel :title="orderInfo.createTime" :status="orderInfo.remark">
                <van-cell-group>
                    <van-field  v-model="orderInfo.tradeNo" label="定单号" readonly />
                    <van-field v-model="orderInfo.payFee" label="需付款" readonly />
                </van-cell-group>
            </van-panel>
            <div class='needPayInfo-btn'>
                <van-button type="primary" size="large" @click="toPay" :loading='submitLoading' loading-text='正在提交...'>确认支付</van-button>
                <div class="needPayInfo-warning">
                    <div style="text-align:left;">温馨提示:</div>
                    <div style="text-align:left;">1,请用户及时支付，以便于我们按时寄送所购产品。</div>
                    <div style="text-align:left;">2,由用户自身原因所产生的拒收或退货，需用户自行承担所产生的运费。</div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
  import {setAesString, getAesString} from "../../../config/date";
  import {isWeiXin} from '../../../common/functionUtil';

export default {
    name: 'packageChoice',
    data(){
        return{
            platform:'weixin',
            submitLoading:false,
            orderCode:null,
            orderInfo:null
        }
    },
    created(){
        //从url中获取
        this.orderCode = this.$route.query.od;
        if(this.orderCode != null){
           this.qryActivityBusinessOrderByOrderCode();
        }else{
            //从缓存中获取
            this.orderInfo = sessionStorage.getItem(setAesString("business"));
            if(this.orderInfo == null){
                this.$dialog.alert({
                    message: '支付信息获取失败,返回上一步!'
                }).then(() => {
                    this.$router.back(-1);//返回上一层
                });
                return;
            }
            //本地获取需解
            this.orderInfo = JSON.parse(getAesString(this.orderInfo));
            this.orderInfo.payFee = this.orderInfo.payFee/100+'元';
        }
    },
    mounted() {
        if(this.isWeiXin()){
            this.platform = "weixin";
        }else{
            this.platform = "other";             
        }
    },
    methods: {
        isWeiXin,
        onClickBack() {
            this.$router.back(-1);//返回上一层
        },
        //查询订单
        qryActivityBusinessOrderByOrderCode(){
            var formdata = {
                service:'user.qryActiveBusinessOrder',
                orderCode:this.orderCode,
            }
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                this.orderInfo = res;
                this.orderInfo.payFee = this.orderInfo.payFee/100+'元';
            },(res)=>{
                this.$toast.fail(res.errorMsg);
            });
        },
        toPay(){
            if(this.orderInfo == null){
                this.$dialog.alert({
                    message: '订单信息不存在,返回上一步重新操作!'
                }).then(() => {
                    this.$router.back(-1);//返回上一层
                });
                return;
            }
            var formdata = {
                service:'user.activeBusinessToPay',
                orderCode:this.orderInfo.tradeNo,
                platform:this.platform,
                successUrl:this.$api.locationUrl+'/activeBusinessPaySuccess?od='+this.orderInfo.tradeNo,
            }
            
             //非微信平台,设置中间页面
            if(this.platform == "other"){
                var redirectUrl = this.$api.locationUrl+"/businessCheckPayResult?od="+setAesString(this.orderInfo.tradeNo);
                formdata.redirectUrl = redirectUrl;
            }

            this.submitLoading = true;
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                this.submitLoading = false;
                window.location.href=res;
            },(res)=>{
                this.submitLoading =false;
                this.$toast.fail(res.errorMsg);
            });
        }
    }
}
</script>

<style lang="less">
@main-blue: #20A0FF;
@main-white: #ffffff;

.needPayInfo{
    height: 100%;
    padding: 10px;
    border-radius: 50px;
    &-data{
        margin-top: 50px;
        background-color:@main-white;
        padding: 20px;
        margin-bottom: 10px;
    }

    &-btn{
        text-align: center;
        margin: 50px 10px;
    }
    &-warning{
        font-size: 12px;
        color:red;
        margin: 10px 10px;
    }
}




</style>
